module.exports = __webpack_public_path__ + "static/thecoaching-73baac80b4ce279ce38ba02bc7f14959.jpg";